module.exports = function(h, row) {
    if (_.isNull(row.components)) {
        return <i class="text-muted">Not Set</i>;
    }

    const list = [];

    row.components.split(',').forEach(component => {
        list.push(
            <li>
                <span class="m-r-xs">{component}</span>
            </li>,
        );
    });

    return <ul>{list}</ul>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/stock/composite-components.jsx